import { useSyncExternalStore } from 'react';

/**
 * "Is this a phone-sized viewport?" — Tailwind's `md` breakpoint (< 768 px),
 * as a reactive hook for the places where a CSS media query isn't enough
 * because the DECISION changes, not just the styling: what to render at all
 * (the desktop-installer link and mobile viewport handling). The server rail
 * uses the wider `lg` breakpoint in HeroApp, where the chat needs more room.
 *
 * Deliberately matches the Tailwind breakpoint so the JS and CSS halves of a
 * layout can't disagree — a mismatch there is how you get a rail that thinks
 * it has room and a container that doesn't.
 */
export const NARROW_QUERY = '(max-width: 767.98px)';

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mql = window.matchMedia(NARROW_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(NARROW_QUERY).matches;
}

export function useIsNarrowViewport(): boolean {
  // Server snapshot is `false`: assume roomy, so a desktop render never flashes
  // the mobile layout before hydration.
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
